import { authRoutes } from '@/auth/constants/routes';
import { onboardingRoutes } from '@/onboarding/constants/routes';

export const PUBLIC_ROUTES = [
  authRoutes.signIn,
  authRoutes.signUp,
  authRoutes.forgotPassword,
  authRoutes.resetPassword,
  onboardingRoutes.createProfile,
];
